module.exports = __webpack_public_path__ + "img/5.552e5651.svg";